import deepcopy from "deepcopy";

const handleSelItem = {
    data() {
        return {

        }
    },
    methods: {
        // 处理筛选显示项
        handleSelItem(val, name, dataCenter = "", lable = "", value = "") {

            const realVal = this.hanleSelectVal(val, name, dataCenter, lable, value)
            const curItem = { val: realVal, name: name }
            const selItemsCopy = deepcopy(this.selItems)
            let overlap = false
            if (selItemsCopy.length) {
                // 检查重复并替换
                selItemsCopy.forEach((item, index) => {
                    if (item.name === name) {
                        overlap = true
                        if (realVal) selItemsCopy[index] = curItem
                        else selItemsCopy.splice(index, 1)
                    }
                });
            }
            if (!overlap && val) selItemsCopy.push(curItem)
            return selItemsCopy
        },
        // 处理select id值转换
        hanleSelectVal(val, name, dataCenter, lable, value) {
           
            let realVal = val
            let arrs = []

            switch (name) {
                case 'zhuangzhiId':
                    arrs = dataCenter
                    break;
                case 'deviceTypeId': // 设备类型
                    arrs = dataCenter.deviceType
                    break;
                case 'workshopId': // 设备组
                    arrs = dataCenter.workShop
                    break;
                case 'customerIndustryId': // 客户行业
                    arrs = dataCenter.consumerIndustry
                    break;
                case 'oilSiteTypeId': // 润滑点
                    arrs = dataCenter.oilSiteType
                    break;
                case 'oilProductId': // 润滑油油品
                    arrs = dataCenter.oilProduct
                    break;
                case 'brandId': // 油品品牌
                    arrs = dataCenter.brand
                    break;
                case 'onLineStatus': // 在线状态
                    arrs = [{ id: 'ONLINE', value: '在线' }, { id: 'OFFLINE', value: '离线' }]
                    break;
                case 'alarmStatus': // 报警状态
                    arrs = [{ id: '1', value: '正常' }, { id: '2', value: '异常' }, { id: '0', value: '报警' }]
                    break;
                case 'transducerTypeId': // 传感器类型
                    arrs = dataCenter.transducerType
                    break;
                case 'oilSiteTypeModelIdentifier': // 指标名称
                    arrs = dataCenter.oilSiteTypeIdentifier
                    break;
                case 'monitoringIndexId': // 报警指标
                    arrs = dataCenter.oilSiteTypeIdentifier
                    break;
                case 'type': // 租户类型
                    arrs = [{ id: '0', value: '经销商' }, { id: '1', value: '客户' }]
                    break;
                case 'warrant': // 是否授权经销商
                    arrs = [{ id: '0', value: '未授权' }, { id: '1', value: '已授权' }]
                    break;
                case 'status': // 租户状态
                    arrs = [{ id: '0', value: '未开通' }, { id: '1', value: '使用中' }, { id: '2', value: '已过期' }]
                    break;
                case 'messageType': // 消息类型
                    arrs = [{ id: 'notice', value: '公告' }, { id: 'advise', value: '通知' }]
                    break;
                case 'messageStatus': // 消息状态

                    arrs = [{ id: 'read', value: '已读' }, { id: 'unread', value: '未读' }]
                    break;
                case 'reportType': // 报告类型
                    arrs = [{ id: 1, value: '润滑点' }, { id: 2, value: '设备报告' }, { id: 3, value: '客户报告' }]
                    break;
                case 'readInfo': // 报告类型
                    arrs = [{ id: 'read', value: '已读' }, { id: 'unread', value: '未读' }]
                    break;
                default:
                    if (dataCenter !== "") {
                        arrs = dataCenter
                    }

                    break;
            }

            const level2Types = ['deviceTypeId', 'customerIndustryId', 'transducerTypeId']
            if (level2Types.indexOf(name) > -1) {
                arrs.forEach(res => {
                    res.children.forEach(ite => {
                        if (ite.id === val) realVal = ite.value
                    })
                })
            } else {

                if (lable == "" && value == "") {
                    arrs.forEach(res => {
                        if (res.id === val) realVal = res.value
                    })
                } else {
                   
                    arrs.forEach(res => {
                      
                        if (res[value] === val) {

                            realVal = res[lable]

                        }
                    })
                }

            }


            return realVal
        },
    }
}

export default handleSelItem